import styled from "styled-components";

export const Dropdown = styled.select`
  padding: 0.75rem 3rem 0.75rem 0.75rem;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  background-color: white;
  cursor: pointer;

  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='32' viewBox='0 0 32 32' width='32' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 9px;

  &:focus {
    outline: none;
    border-color: #000000;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: #f8f9fa;
  }
`;
